import React from 'react';
import styled from 'styled-components';

import { ChevronIcon } from 'src/presentation/components/pages/sidekick/threads/components/ThreadBuilder/ExpandButton';
import ActionButton from 'src/presentation/components/pages/sidekick/threads/components/ThreadBuilder/ActionButton';

type ExpandCollapseButtonProps = {
  hasChildren: boolean;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  title?: { expanded: string; collapsed: string };
};

const ExpandCollapseButton = ({
  hasChildren,
  isOpen,
  setIsOpen,
  title = { expanded: 'Hide', collapsed: 'Show' },
}: ExpandCollapseButtonProps) => {
  const ctrlTitle = hasChildren ? (isOpen ? title.expanded : title.collapsed) : undefined;

  return (
    <StyledActionButton
      className="chevron-icon"
      hasModifiers={hasChildren}
      onClick={evn => {
        evn.stopPropagation();
        setIsOpen(!isOpen);
      }}
      title={ctrlTitle}
    >
      <ChevronIcon data-isopen={isOpen} disabled={false} alt={ctrlTitle} />
    </StyledActionButton>
  );
};

const StyledActionButton = styled(ActionButton)`
  ${p => (p.hasModifiers ? `visibility: visible;` : `visibility: hidden;`)};
  z-index: 0;
`;

export default ExpandCollapseButton;
